import { Avatar, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ArrowBackBlue, Supplier1, Supplier2 } from 'Images';
import { TreatmentAlert } from '../TreatmentAlert';
import { ISupplierCard, SupplierCard } from '../SupplierCard';
import React, { Fragment } from 'react';
import { getSupplierRedirectCode } from 'API/Treatment/treatment';

enum SUPPLIER_NAME {
  flying = 1,
  eshet = 2,
}
interface ITreatmentSupplier {
  userId: string;
}
export const TreatmentSupplier = ({ userId }: ITreatmentSupplier) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Treatment);
  const isDesktop = useIsDesktop();

  const navigateToSupplier = async (supplierID: number) => {
    const newWindow = window.open();
    const code = await getSupplierRedirectCode(supplierID);
    let redirectUrl = '';
    if (supplierID === SUPPLIER_NAME.eshet)
      redirectUrl = Dictionary[DICTIONARY.General].eshetTursUrl;
    else redirectUrl = Dictionary[DICTIONARY.General].flyingCarpetUrl;
    if (code && newWindow) {
      newWindow.location = `${redirectUrl}/?code=${encodeURIComponent(code)}`;
    } else newWindow?.close();
  };

  const suppliers: ISupplierCard[] = [
    {
      keyIndex: 2,
      onClick: () => navigateToSupplier(SUPPLIER_NAME.flying),
      supplierLogo: Supplier2,
      supplierLogoAlt: dictionary.recentOrders.flyingCarpet,
      supplierVideoHref: dictionary.treatmentSupplier.shatiahVideo,
    },
    {
      keyIndex: 1,
      onClick: () => navigateToSupplier(SUPPLIER_NAME.eshet),
      supplierLogo: Supplier1,
      supplierLogoAlt: dictionary.recentOrders.eshetTours,
      supplierVideoHref: dictionary.treatmentSupplier.eshetVideo,
    },
  ];

  return (
    <Stack gap={isDesktop ? '40px' : '32px'}>
      <Stack gap={isDesktop ? '24px' : '16px'}>
        <Stack gap={isDesktop ? '8px' : '4px'}>
          <Typography component={'h2'} variant={'h5'} color={'text.secondary'}>
            {dictionary.treatmentSupplier.title}
          </Typography>
          <Typography variant={'body3'} color={'text.secondary'}>
            {dictionary.treatmentSupplier.subtitle}
          </Typography>
        </Stack>
        <TreatmentAlert
          alertSx={{
            '&.MuiPaper-root': {
              backgroundColor: 'primary.shade_100',
              padding: isDesktop ? '16px 60px 16px 24px' : '4px 12px',
            },
          }}
        >
          {isDesktop ? (
            <Stack display={'inline'} position={'relative'} top={'-5px'}>
              <Typography
                display={'inline'}
                variant='body3'
                sx={{ lineHeight: '35px !important' }}
              >
                {dictionary.treatmentSupplier.info}{' '}
              </Typography>
              <Link
                underline={'hover'}
                sx={{ display: 'inline' }}
                href={dictionary.infoLinkUrl}
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  event.preventDefault();
                  window.open(dictionary.infoLinkUrl, '_blank');
                }}
              >
                {dictionary.treatmentSupplier.info2Label}
              </Link>
              <Avatar
                src={ArrowBackBlue}
                alt={''}
                style={{
                  width: '16px',
                  height: '16px',
                  position: 'absolute',
                  bottom: ' 3px',
                  left: '-18px',
                }}
              />
            </Stack>
          ) : (
            <Stack gap={isDesktop ? '8px' : '4px'}>
              <Typography variant='body3' color={'text.secondary'}>
                {dictionary.treatmentSupplier.info}
              </Typography>
              <Link
                width={'fit-content'}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                underline='hover'
                href={dictionary.infoLinkUrl}
              >
                <Typography variant='body2' whiteSpace={'nowrap'}>
                  {dictionary.treatmentSupplier.info2Label}
                </Typography>
                <Avatar
                  alt={''}
                  src={ArrowBackBlue}
                  sx={{ width: '16px', height: '16px', margin: 0 }}
                />
              </Link>
            </Stack>
          )}
        </TreatmentAlert>
      </Stack>

      <Stack direction={'row'} gap={isDesktop ? '48px' : '17px'}>
        {suppliers.map((supplier, index) => (
          <Fragment key={index}>
            <SupplierCard {...supplier} />
          </Fragment>
        ))}
      </Stack>
    </Stack>
  );
};
